import { Button, ConfigProvider, Modal } from "antd";
import { useMemo } from "react";

interface DeleteModalProps {
  loading: boolean;
  topicName: string | undefined;
  topicType: string;
  confirmationText?: string;
  onCancel: () => void;
  onSubmit: () => void;
}

export const DeleteModal = ({
  loading,
  topicName,
  topicType,
  confirmationText,
  onCancel,
  onSubmit
}: DeleteModalProps) => {
  const displayText = useMemo(() => {
    if (confirmationText) {
      return confirmationText;
    }

    if (topicType === "building-block") {
      return "Are you sure you want to delete this building block's content and versions? A new, blank, building block will be created in it's place.";
    }

    return "Are you sure you want to delete this document and all of its versions?";
  }, [confirmationText, topicType]);
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBorderColor: "rgb(44, 21, 97)",
            defaultHoverBorderColor: "rgb(64, 41, 117)", // 20 pxs lighter
            defaultBg: "rgb(44, 21, 97)",
            defaultHoverBg: "rgb(64, 41, 117)", // 20 pxs lighter
            defaultColor: "white"
          }
        }
      }}
    >
      <Modal
        className="w-[400px]"
        open={true}
        closable={true}
        onCancel={onCancel}
        footer={[
          <Button
            key="back"
            type="default"
            style={{ color: "white" }}
            onClick={onCancel}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="default"
            style={{ color: "white" }}
            loading={loading}
            onClick={onSubmit}
          >
            Delete
          </Button>
        ]}
      >
        <p className="font-bold">{topicName}</p>
        <p>{displayText}</p>
      </Modal>
    </ConfigProvider>
  );
};
